import { render, staticRenderFns } from "./ProductSave.vue?vue&type=template&id=8b673c34"
import script from "./ProductSave.vue?vue&type=script&lang=js"
export * from "./ProductSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports